import { CommonDetailViewModel } from './common-detail-view.model';
import { CustomerIndividualName } from '../customer-individual-name.model';
import { AuthorizedPresence } from '../authorized-presence.model';
import { CustomerIndividualBiometric } from '../customer-individual-biometric.model';
import { CustomerIndividualMedicalAlert } from '../customer-individual-medical-alert.model';
import { CustomerCertification } from '../customer-certification.model';

export class IndividualDetailViewModel extends CommonDetailViewModel {
    public nameDetail: CustomerIndividualName;
    public authorizedPresence: AuthorizedPresence;
    public biometric: CustomerIndividualBiometric;
    public akas: CustomerIndividualName[];
    public medicalAlerts: CustomerIndividualMedicalAlert[];
    public certifications: CustomerCertification[];
    public isACP: boolean;
    public level: number;

    constructor() {
        super();

        this.biometric = new CustomerIndividualBiometric();
        this.nameDetail = new CustomerIndividualName();
        this.authorizedPresence = new AuthorizedPresence();
        this.akas = new Array();
        this.medicalAlerts = new Array();
        this.certifications = new Array();
    }
}
